<template>
  <div class="enterprise-innovation-page">
    <el-tabs v-model="activeTab" class="rule-tabs">
      <el-tab-pane label="企业数据" name="company">
        <company-data-config ref="company" />
      </el-tab-pane>
      <el-tab-pane label="赋分模型计算标准" name="scores">
        <score-standard-config ref="scores" />
      </el-tab-pane>
      <el-tab-pane label="加分项评分标准" name="bonus">
        <bonus-rule-config ref="bonus" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CompanyDataConfig from './innovationPointsSystem/components/CompanyDataConfig.vue';
import ScoreStandardConfig from './innovationPointsSystem/components/ScoreStandardConfig.vue';
import BonusRuleConfig from './innovationPointsSystem/components/BonusRuleConfig.vue';

export default {
  name: 'InnovationPointsSystem',
  components: { CompanyDataConfig, ScoreStandardConfig, BonusRuleConfig },
  data() {
    return { activeTab: 'company' };
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    hasUnsavedChanges() {
      return ['company', 'scores', 'bonus'].some(key => {
        const component = this.$refs[key];
        return component && component.hasChanges && component.hasChanges();
      });
    },
    handleBeforeUnload(event) {
      if (!this.hasUnsavedChanges()) return;
      event.preventDefault();
      event.returnValue = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.enterprise-innovation-page {
  min-width: 900px;
  padding: 8px 20px 24px;

  ::v-deep .rule-tabs > .el-tabs__header {
    margin-bottom: 20px;
  }

  ::v-deep .rule-tabs .el-tabs__item {
    height: 44px;
    line-height: 44px;
  }
}
</style>
